export default __webpack_public_path__ + "static/media/groupActivity.64569387.png";